import { render, staticRenderFns } from "./loan-record.vue?vue&type=template&id=1aeeae4e&scoped=true&"
import script from "./loan-record.vue?vue&type=script&lang=ts&"
export * from "./loan-record.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeeae4e",
  null
  
)

export default component.exports